// frontend/src/utils/gridExport.js
//
// Whole-result-set Excel download for a server-paged Syncfusion grid.
//
// **A server-paged grid must not use Syncfusion's own `excelExport()`**: that
// writes out the rows the grid is holding, which is one page, in a file named
// after the whole list. `apps.core.grid_export.GridExportMixin` adds
// `GET <list-url>export/`, which re-runs the same filtered queryset on the
// server; this is the client half of that contract.
//
// Pass the SAME params the grid is currently showing, or the spreadsheet and
// the screen disagree about what was exported.

import api from '../services/api';

export const downloadGridExport = async (endpoint, params = {}, filename = 'export') => {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ''),
  );
  const response = await api.get(`${endpoint}export/`, { params: clean, responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  }));
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}_${new Date().toLocaleDateString('en-CA')}.xlsx`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export default downloadGridExport;
